import FilterConstants from '../../filter-constants';
import RecommendedSpecific from './recommended-specific';

export default class AllowedSpecific extends RecommendedSpecific {
  name = FilterConstants.optimizationType.allowedSpecific;

  getOpAmpRequirementSpecValues(stopbandFrequency) {
    var base = this; // to specify which one comes from the base class;
    var specs = {
      fMultiplier: 5, //bigger is more strict:  used for highpass
      allowedError: 0.2, //Don't make this 0.5 or larger. In high speed cases, gets multiplied by 2, then low pass first order chokes when 1 or higher.
      rOutFreqMultiplier: 1, //rout shouldn't come into play until 5x stopband
      inductorMultiplier: 3,
      dcOutputVoltageFromIBias: 5,
      stopbandFrequency: stopbandFrequency,
    };

    specs.f = stopbandFrequency * specs.rOutFreqMultiplier;

    var result = base.adjustOpAmpRequirementSpecs(specs, stopbandFrequency);

    return result;
  }
}
